/**
 * Извлекает slug из полного URL страницы
 * @param {string} pageUrl - Полный URL страницы (например, https://foreverstudios.com/pod/companyKey/my-page)
 * @param {string} companyPageKey - Ключ компании (например, companyKey)
 * @returns {string} Slug страницы или пустая строка
 */
export function extractSlugFromUrl(pageUrl, companyPageKey) {
  if (!pageUrl || !companyPageKey) return '';

  const prefix = `pod/${companyPageKey}/`;
  const idx = pageUrl.indexOf(prefix);

  if (idx === -1) return '';

  return pageUrl.slice(idx + prefix.length);
}

/**
 * Формирует полный ключ страницы для API
 * @param {string} companyPageKey - Ключ компании
 * @param {string} slug - Slug страницы (может быть пустым)
 * @returns {string} Полный ключ (например, pod/companyKey/my-page или pod/companyKey)
 */
export function buildPageKey(companyPageKey, slug) {
  if (!companyPageKey) return '';

  return slug ? `pod/${companyPageKey}/${slug}` : `pod/${companyPageKey}`;
}

/**
 * Получает полный ключ страницы из объекта страницы и ключа компании
 * @param {Object} page - Объект страницы с полем url
 * @param {string} companyPageKey - Ключ компании
 * @returns {string} Полный ключ страницы
 */
export function getFullPageKey(page, companyPageKey) {
  const slug = extractSlugFromUrl(page?.url, companyPageKey);
  return buildPageKey(companyPageKey, slug);
}
